// Example presets with images, prompts and results for Image Editing
export interface ExamplePreset {
  id: number;
  name: string;
  preview: string;
  preview2?: string; // For optional second input image
  prompt: string;
  results: string[];
}

export const examplePresets: ExamplePreset[] = [
  {
    id: 1,
    name: 'Man in Blazer',
    preview: 'https://storage.googleapis.com/xdesign-d72cd.appspot.com/uploaded_image/image_editing/Yqsl85WkdWellAJHbVgrZhu9lBS2/0bd41b2f-9426-4e27-864b-55d82c3b02ec.jpg/867a0317-eca9-4d82-9154-d9afe22b94f2',
    prompt: 'I want a man wearing the blazer with the cloth provided with black formal pant Do not change any pattern and design of clothes provided.',
    results: [
      'https://storage.googleapis.com/xdesign-d72cd.appspot.com/uploaded_image/image_editing/lMpe6oraQRRBYDYmBJyIqydYvTz1/e0e81259-9677-43af-8795-f211cc6748f6/8a470c6c-d2b2-416b-8f9a-8eb309e10579'
    ]
  },
  {
    id: 2,
    name: 'Skirt Cloth Swap',
    preview: 'https://storage.googleapis.com/xdesign-d72cd.appspot.com/uploaded_image/image_editing/Yqsl85WkdWellAJHbVgrZhu9lBS2/9dbc9769-7587-4e5c-a73d-9f2aa74d681b.jpeg/77f0a2b2-ca5e-447c-9191-6e2230bdbdc2',
    preview2: 'https://storage.googleapis.com/xdesign-d72cd.appspot.com/uploaded_image/image_editing/Yqsl85WkdWellAJHbVgrZhu9lBS2/6476c441-51f7-46d3-88aa-d053afa35e03.jpg/28bb45a7-4770-44da-901a-9bedc1dc6f83',
    prompt: 'Change the skirt cloth from Image1 to Cloth given in Image2',
    results: [
      'https://storage.googleapis.com/xdesign-d72cd.appspot.com/uploaded_image/image_editing/lMpe6oraQRRBYDYmBJyIqydYvTz1/302cb2d9-2e28-4d8f-bed8-ffde2fecb7ab/a9e49cd7-ca7b-48f5-8c50-b70240f621a0'
    ]
  }
];

